import { FileUploadAndParse } from "@fronterahealth/frontera-ui-components";

import { FileTypeEnum, useStartLearnerMetadataCreationFromAbcIntakeFileMutation } from "@api/graphql/types-and-hooks";
import {
  useGetIntakeFileParseStatusRetriever,
  useGetIntakeFileUploadCompleteCallback,
  useGetIntakeRemoveFileCallback,
  useGetIntakeS3BucketUploadCallback,
  useIntakeS3BucketUrlRetriever,
} from "@components/CreateNewClientDialog/hooks";

interface UploadABCIntakeFileProps {
  setLearnerId: (learnerId: string | undefined) => void;
  disabled: boolean;
  fileUploadedCallback: () => void;
  setLearnerFileId: (learnerFileId: string | undefined) => void;
  onFileRemoved?: () => void;
  onFileUploadStarted?: () => void;
}

export const UploadABCIntakeFile: React.FC<UploadABCIntakeFileProps> = ({
  setLearnerId,
  disabled,
  fileUploadedCallback,
  setLearnerFileId,
  onFileRemoved,
  onFileUploadStarted,
}) => {
  const baseS3BucketUrlRetriever = useIntakeS3BucketUrlRetriever(setLearnerId);
  const S3BucketUrlRetriever: typeof baseS3BucketUrlRetriever = async (params) => {
    onFileUploadStarted?.();
    return baseS3BucketUrlRetriever(params);
  };
  const S3BucketUploadCallback = useGetIntakeS3BucketUploadCallback();
  const metadataCreationMutation = useStartLearnerMetadataCreationFromAbcIntakeFileMutation();
  const reportFileUploadCompleteCallback = useGetIntakeFileUploadCompleteCallback(
    metadataCreationMutation,
    "startLearnerMetadataCreationFromAbcIntakeFile",
  );
  const fileParseStatusRetriever = useGetIntakeFileParseStatusRetriever(fileUploadedCallback, setLearnerFileId);
  const baseRemoveFileCallback = useGetIntakeRemoveFileCallback(setLearnerFileId);
  const removeFileCallback = async (fileId: string) => {
    await baseRemoveFileCallback(fileId);
    onFileRemoved?.();
  };
  return (
    <FileUploadAndParse
      key="abc_intake"
      fileKind={FileTypeEnum.ActionBehavioralCenterIntake}
      title=""
      supportedFileTypes={["pdf"]}
      maxSize={"20MB"}
      singleFileUpload
      S3BucketUrlRetriever={S3BucketUrlRetriever}
      S3BucketUploadCallback={S3BucketUploadCallback}
      reportFileUploadCompleteCallback={reportFileUploadCompleteCallback}
      fileParseStatusRetriever={fileParseStatusRetriever}
      removeFileCallback={removeFileCallback}
      disabled={disabled}
    />
  );
};
